(function() {
'use strict';

angular
    .module('TR')
    .service('mandatoryTransferService', mandatoryTransferService);

function mandatoryTransferService($filter) {
    const service = {
        generateMandatoryOptions,
        addFlightDetails,
        getTransfers,
        findSelectedTransfer,
        generateOptionId,
        getRoomsWithTransfers,
        generateOptionsForMultiRooms,
        getOptions,
        addDeltas,
        getSelectedPrices,
        getSelectedTransfers,
        getHolidayRoomsWithTransfers,
        getBookedTransfersPrice
    };

    let FlightDetails;
    let Options;
    const mandatoryTransferTypeId = 23;

    function generateMandatoryOptions(roomId, flightDetails) {
        FlightDetails = flightDetails;
        Options = flightDetails.options || [{ OptionId: generateOptionId(roomId, flightDetails.transfer.HotelExtraId, flightDetails.transfer.HotelExtraOptionId) }];
    }

    function addFlightDetails(connectingFlight) {
        const fd = FlightDetails;
        const cf = connectingFlight;

        if (fd && cf && cf.InboundDate && cf.OutboundDate) {
            cf.InboundDate = _setTime(cf.InboundDate, fd.departureTime.hours, fd.departureTime.minutes);
            cf.OutboundDate = _setTime(cf.OutboundDate, fd.arrivalTime.hours, fd.arrivalTime.minutes);
            cf.InboundFlightNumber = fd.inboundFlightNum;
            cf.OutboundFlightNumber = fd.outboundFlightNum;
        }
        return cf;
    }

    function getTransfers(extras = []) {
        let transfers = [];
        extras && extras.forEach(item => {
            if (item && item.IsMandatory && item.HotelExtraTypeId === '2') { // typeId = 2 for mandatory transfers
                let HotelExtraId = item.HotelExtraId;
                let options = item.Options || [];
                if (options.length > 0) {
                    options.forEach(value => {
                        value.HotelExtraId = HotelExtraId;
                        transfers.push(value);
                    });
                }
            }
        });
        return transfers;
    }

    function findSelectedTransfer(transfers = [], includedExtras = []) {
        let transfer;
        let includedTransfer;
        includedExtras.forEach(inclExt => {
            if (inclExt && inclExt.ExtraTypeId === '2') {
                includedTransfer = inclExt;
            }
        });
        transfers.forEach(item => {
            if (includedTransfer && item && Math.round(includedTransfer.ClientPrice) === Math.round(item.GrossCost)
                && includedTransfer.Title === item.Title) {
                transfer = item;
            }
        });
        return transfer;
    }

    function getRoomsWithTransfers(hotel, roomGridData, selectedPrices) {
        let selectedRooms = [];
        for (let i = 0; i < hotel.Rooms.length; i++) {
            let selectedRoom = (hotel.Rooms[i].FilteredAvailability || hotel.Rooms[i].Availability)
                                    .find(item => item.Id === selectedPrices[`id${i}`]);
            selectedRoom = selectedRoom.BoardOptions.find(item => item.Id === selectedPrices[`id${i}`]);
            selectedRoom.roomId = roomGridData[i].Id;
            selectedRoom.roomNumber = roomGridData[i].Id.match(/\d+/)[0];
            selectedRoom.roomTitle = `Room ${parseInt(selectedRoom.roomNumber) + 1}`;
            selectedRoom.nonInfants = roomGridData[i].nonInfants;
            selectedRoom.mandatoryTransfers = getTransfers(selectedRoom.Extras) || [];
            if (selectedRoom.mandatoryTransfers.length > 0) {
                selectedRooms.push(selectedRoom);
            }
        }
        return selectedRooms;
    }

    function getHolidayRoomsWithTransfers(hotel) {
        let selectedRooms = [];
        if (hotel.BookedItems) {
            for (let i = 0; i < hotel.BookedItems.length; i++) {
                let includedTransfer = getTransfers(hotel.AvailableExtrasPerRoom[i]);
                if (hotel.BookedItems[i] && Object.keys(includedTransfer).length !== 0) {
                    let roomWithTransfer = Object.assign(hotel.BookedItems[i]);
                    roomWithTransfer.roomNumber = `id${i}`;
                    roomWithTransfer.roomTitle = `Room ${i + 1}`;
                    roomWithTransfer.nonInfants = roomWithTransfer.Adults;
                    roomWithTransfer.mandatoryTransfers = includedTransfer;
                    selectedRooms.push(roomWithTransfer);
                }
            }
        }
        return selectedRooms;
    }

    function generateOptionId(roomNumberId = '0id', HotelExtraId, HotelExtraOptionId) {
        const hotelExtra = 'HotelExtra';
        const roomNumberIdPrefix = 'id';
        let roomNumber = +roomNumberId.split(roomNumberIdPrefix).pop();
        return `${hotelExtra}|${roomNumber}|${HotelExtraId}|${HotelExtraOptionId}`;
    }

    function generateOptionsForMultiRooms(flightDetails, rooms = []) {
        let options = [];
        for (let i = 0; i < rooms.length; i++) {
            let option = {};

            const hotelExtraId = flightDetails && flightDetails.transfers && flightDetails.transfers[i] && flightDetails.transfers[i].HotelExtraId;
            const hotelExtraOptionId = flightDetails && flightDetails.transfers && flightDetails.transfers[i] && flightDetails.transfers[i].HotelExtraOptionId;
            option.OptionId = generateOptionId(rooms[i].roomNumber, hotelExtraId, hotelExtraOptionId);
            options.push(option);
        }
        return options;
    }

    function getOptions() {
        return Options;
    }

    function addDeltas(transfers, cheapestTransfer) {
        return transfers.map(t => {
            t.deltaPrice = t.GrossCost - cheapestTransfer.GrossCost;
            return t;
        });
    }

    function _setTime(date, hours, minutes) {
        date = new Date(date);
        date.setMinutes(minutes);
        date.setHours(hours);
        return $filter('date')(date, 'yyyy-MM-ddTHH:mm:ss');
    }

    function getSelectedPrices(hotelData, bookedHotelData) {
        let selectedPrices = {};
        if (hotelData.Rooms) {
            for (let i = 0; i < hotelData.Rooms.length; i++) {
                const roomDescription = bookedHotelData.Details.BookedItems[i].RoomDescription;
                if (hotelData.Rooms && hotelData.Rooms.length > 0) {
                    hotelData.Rooms[i].Availability.map(room => {
                        if (room.RoomDescription === roomDescription) {
                            selectedPrices[`id${i}`] = room.Id;
                        }
                        return selectedPrices;
                    });
                }
            }
        }
        return selectedPrices;
    }

    function getSelectedTransfers(hotel, rooms) {
        let bookedTransfers = [];
        hotel.CostBreakdown.map(item => {
            if (item.TypeId === mandatoryTransferTypeId) {
                bookedTransfers.push(item);
            }
            return bookedTransfers;
        });
        for (let i = 0; i < bookedTransfers.length; i++) {
            bookedTransfers[i] = rooms[i].mandatoryTransfers.find(item => item.GrossCost === bookedTransfers[i].UnitAmount);
        }
        return bookedTransfers;
    }

    function getBookedTransfersPrice(costBreakdown) {
        let transfersCost = 0;
        costBreakdown && costBreakdown.map(item => {
            if (item.TypeId === mandatoryTransferTypeId) {
                transfersCost += item.UnitAmount;
            }
            return transfersCost;
        });
        return transfersCost;
    }

    return service;
}
})();
